export enum UserType {
    Internal ,
    External ,
    Admin,
}